import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { TabsModule } from 'ngx-bootstrap/tabs';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { SlimTableComponent } from './slim-table/slim-table.component';
import { ContactEmailComponent } from './contact-email/contact-email.component';
import { CharacterisationStatusTableComponent } from './characterisation-status-table/characterisation-status-table.component';
import { QueryLinkComponent } from './query-link/query-link.component';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { ApiErrorDisplayComponent } from './api-error-display/api-error-display.component';
import { ExternalLinkComponent } from './external-link/external-link.component';
import { GeneResultsComponent } from './gene-results/gene-results.component';
import { GeneResultsSubsetCountComponent } from './gene-results-subset-count/gene-results-subset-count.component';
import { GeneResultsVisComponent } from './gene-results-vis/gene-results-vis.component';
import { GenesTableComponent } from './genes-table/genes-table.component';
import { GeneLinkComponent } from './gene-link/gene-link.component';
import { PageContentsMenuComponent } from './page-contents-menu/page-contents-menu.component';
import { CvVersionComponent } from './cv-version/cv-version.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { DetailsPageMenuComponent } from './details-page-menu/details-page-menu.component';
import { SeqFeatureTableComponent } from './seq-feature-table/seq-feature-table.component';
import { GoCamTableComponent } from './go-cam-table/go-cam-table.component';
import { GocamOverlapsTableComponent } from './gocam-overlaps-table/gocam-overlaps-table.component';
import { GoCamHolesTableComponent } from './gocam-holes-table/gocam-holes-table.component';
import { NgxPageScrollCoreModule } from 'ngx-page-scroll-core';
import { NgxPageScrollModule } from 'ngx-page-scroll';

import { DatasetVersionsComponent } from './dataset-versions/dataset-versions.component';
import { PredefinedQueryResultsComponent } from './predefined-query-results/predefined-query-results.component';
import { SocialContactComponent } from './social-contact/social-contact.component';
import { GeneResultsSlimTableComponent } from './gene-results-slim-table/gene-results-slim-table.component';
import { FacetedSearchComponent } from './faceted-search/faceted-search.component';
import { ChromosomeOverviewComponent } from './chromosome-overview/chromosome-overview.component';
import { FeatureStatsComponent } from './feature-stats/feature-stats.component';
import { DescriptionDisplayComponent } from './description-display/description-display.component';

import { PublicationBadgeComponent } from './publication-badge/publication-badge.component';
import { TestimonialListComponent } from './testimonial-list/testimonial-list.component';
import { PdbStructureViewerComponent } from './pdb-structure-viewer/pdb-structure-viewer.component';
import { ReferenceShortComponent } from './reference-short/reference-short.component';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    NgxPageScrollCoreModule.forRoot({duration: 0}),
    NgxPageScrollModule,
    TabsModule.forRoot(),
    PopoverModule.forRoot(),
    BsDropdownModule.forRoot(),
    FontAwesomeModule,
  ],
  exports: [
    SlimTableComponent,
    ContactEmailComponent,
    CharacterisationStatusTableComponent,
    QueryLinkComponent,
    PredefinedQueryResultsComponent,
    LoadingSpinnerComponent,
    ApiErrorDisplayComponent,
    ExternalLinkComponent,
    GeneResultsComponent,
    GeneResultsSubsetCountComponent,
    GeneResultsVisComponent,
    GenesTableComponent,
    GeneLinkComponent,
    PageContentsMenuComponent,
    CvVersionComponent,
    NotFoundComponent,
    DetailsPageMenuComponent,
    SeqFeatureTableComponent,
    GoCamTableComponent,
    GocamOverlapsTableComponent,
    GoCamHolesTableComponent,
    DatasetVersionsComponent,
    SocialContactComponent,
    GeneResultsSlimTableComponent,
    FacetedSearchComponent,
    ChromosomeOverviewComponent,
    FeatureStatsComponent,
    PublicationBadgeComponent,
    DescriptionDisplayComponent,
    TestimonialListComponent,
    PdbStructureViewerComponent,
    ReferenceShortComponent,
  ],
  declarations: [
    SlimTableComponent,
    ContactEmailComponent,
    CharacterisationStatusTableComponent,
    QueryLinkComponent,
    PredefinedQueryResultsComponent,
    LoadingSpinnerComponent,
    ApiErrorDisplayComponent,
    ExternalLinkComponent,
    GeneResultsComponent,
    GeneResultsSubsetCountComponent,
    GeneResultsVisComponent,
    GenesTableComponent,
    GeneLinkComponent,
    PageContentsMenuComponent,
    CvVersionComponent,
    NotFoundComponent,
    DetailsPageMenuComponent,
    SeqFeatureTableComponent,
    GoCamTableComponent,
    GocamOverlapsTableComponent,
    GoCamHolesTableComponent,
    DatasetVersionsComponent,
    SocialContactComponent,
    GeneResultsSlimTableComponent,
    DescriptionDisplayComponent,
    FacetedSearchComponent,
    ChromosomeOverviewComponent,
    FeatureStatsComponent,
    PublicationBadgeComponent,
    TestimonialListComponent,
    PdbStructureViewerComponent,
    ReferenceShortComponent,
  ],
})
export class SharedModule { }
